import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { changePassword } from "../../../utils/usermanagement";

// import images
// import profile from "../../assets/images/bg.png";
import { layoutModeTypes } from "../../../Components/constants/layout";
import logoDark from '../../../assets/images/exiaLogo_dark.png';
import logoLight from '../../../assets/images/exiaLogo_light.png';
import ParticlesAuth from "../../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";

const ChangePassword = props => {
  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
        newPassword: '',
        confirmPassword: ''
    },
    validationSchema: Yup.object({
      newPassword: Yup.string().required("Please Enter Your new password"),
      confirmPassword: Yup.string().required("Please Enter Your confirm password").oneOf([Yup.ref('newPassword')], 'The two passwords you entered do not match.'),
    }),
    onSubmit:async (values) => {
      
      try { 
        values.sessionCode = sessionStorage.getItem("sessionCode", null); 
          const response = await changePassword(values);
          
          if (response.code === 200) {  
              successnotify("password  change successfully!");  
              const token = response.token;
              const refreshToken = response.refreshToken;
              const user = {
                  id: response.response.data.user.id,
                  name: response.response.data.user.name,
                };
              sessionStorage.setItem("authToken", token);
              sessionStorage.setItem("refreshToken", refreshToken);
              sessionStorage.setItem("user", JSON.stringify(user));
              props.router.navigate("/commingSoon"); // Redirect to a protected page
        } else if (response.code === 404) {
            alert(response.message);
        } else {
            // setError(response.message);
            console.error("Error:",response.message);
        }
    } catch (err) {
        console.error('submit failed. Please try again.Error', err);
        // setError('Login failed. Please try again.');
    }
    }
  });

  const selectLayoutState = (state) => state.ForgetPassword;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (state) => ({
      forgetError: state.forgetError,
      forgetSuccessMsg: state.forgetSuccessMsg,
    })
  );
  // Inside your component
  const {
    forgetError, forgetSuccessMsg
  } = useSelector(selectLayoutProperties);

  // Get the current layout mode from Redux store
  const selectLayoutModeState = (state) => state.Layout;
  const layoutModeData = createSelector(
    selectLayoutModeState,
    (layout) => ({
      layoutModeType: layout.layoutModeType,
    })
  );
  const { layoutModeType } = useSelector(layoutModeData);

  // Use the actual layout mode from Redux instead of hardcoded logic
  const mode = layoutModeType || layoutModeTypes.LIGHTMODE;
  
  document.title="Reset Password | SeedNations";

  return (
    <ParticlesAuth>
      <div className="auth-page-content">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                  {/* Logo logic: Light mode shows light logo, Dark mode shows dark logo */}
                  <img src={mode === layoutModeTypes.LIGHTMODE ? logoLight : logoDark} alt="" height="200" />
                  </Link>
                </div>
                <p className="mt-3 fs-15 fw-medium">Put Seed Nations slogan here</p>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">

                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">input your new password here</h5> 
 

                  </div>

                  {/* <Alert className="border-0 alert-warning text-center mb-2 mx-2" role="alert">
                    Enter your email and instructions will be sent to you!
                  </Alert> */}
                  <div className="p-2">
                    {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null}
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label className="form-label">new Password</Label>
                        <Input
                          name="newPassword"
                          className="form-control"
                          placeholder="Enter newPassword"
                          type="newPassword"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.newPassword || ""}
                          invalid={
                            validation.touched.newPassword && validation.errors.newPassword ? true : false
                          }
                        />
                        {validation.touched.newPassword && validation.errors.newPassword ? (
                          <FormFeedback type="invalid"><div>{validation.errors.newPassword}</div></FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-4">
                        <Label className="form-label">confirm Password</Label>
                        <Input
                          name="confirmPassword"
                          className="form-control"
                          placeholder="Enter confirmPassword"
                          type="confirmPassword"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.confirmPassword || ""}
                          invalid={
                            validation.touched.confirmPassword && validation.errors.confirmPassword ? true : false
                          }
                        />
                        {validation.touched.confirmPassword && validation.errors.confirmPassword ? (
                          <FormFeedback type="invalid"><div>{validation.errors.confirmPassword}</div></FormFeedback>
                        ) : null}
                      </div>

                      <div className="text-center mt-4">
                        <button className="btn  w-100"  style={{backgroundColor:'#24F4C0',color:'#000'}} type="submit">Submit</button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
 
            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

ChangePassword.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ChangePassword);
